import classNames from 'classnames';

type ActionTileProps = {
  title: string;
  description: string;
  icon?: string;
  externalIcon?: string;
  onClick: () => void;
  'data-testid'?: string;
};

export const ActionTile = ({
  title,
  description,
  icon,
  externalIcon,
  onClick,
  'data-testid': dataTestId,
}: ActionTileProps) => {
  return (
    <span
      className={classNames(
        'height-100pct',
        'rounded',
        'display-flex',
        'align-items-start',
        'gap-20',
        'text-decoration-none',
        'user-select-none',
        'hover-bg-lightest',
        'padding-15',
        'link',
      )}
      onClick={onClick}
      data-testid={dataTestId}
    >
      {(icon || externalIcon) && (
        <div className="position-relative padding-20 border border-size-2 border-color-primary">
          <div className="inset-0 display-grid place-items-center">
            {icon ? (
              <span className={`text-size-20 rioglyph rioglyph-${icon}`} />
            ) : (
              <span
                className={'text-size-20 rioglyph'}
                style={{ '--i': `url(${externalIcon})` } as React.CSSProperties}
              />
            )}
          </div>
        </div>
      )}
      <div className="line-height-125rel margin-top--3">
        <div className="text-size-18 text-medium margin-bottom-3 text-color-primary">
          {title}
        </div>
        <div className="text-size-14 text-color-darkest">{description}</div>
      </div>
    </span>
  );
};
